
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import { StudyCategory } from '@/models/StudyCategory'
import SelectModal from '@/components/templates/SelectModal.vue'

/**
 * 講習会トレーニング教材選択モーダル
 */
@Component({
  components: {
    SelectModal,
  },
})
export default class ModalSelectSeminarStudyCategory extends Vue {
  /** 選択用モーダル */
  @Ref()
  private selectModal!: SelectModal

  /** ボタン押下時のイベント */
  @Prop()
  private eventSubmitStudyCategory!: (code: string) => void

  /** 講習会トレーニング教材のリスト */
  private studyCategoryList: StudyCategory.Seminar[] = []

  /**
   * 講習会トレーニング教材コード一覧
   *
   * @returns 講習会トレーニング教材コードのリスト
   */
  private get studyCategoryCodeList(): string[] {
    return this.studyCategoryList.map((category) => category.code)
  }

  /**
   * ボタン押下時のイベント
   */
  private submitStudyCategory(): void {
    this.selectModal.hide()
    this.eventSubmitStudyCategory(this.selectModal.currentItemCode || '')
  }

  /**
   * 講習会トレーニング教材コードからラベルを引当てて返す
   *
   * @param code 講習会トレーニング教材コード
   * @returns 講習会トレーニング教材のラベル
   */
  private getLabelByCode(code: string): string {
    const label = this.studyCategoryList.find((category) => category.code === code)?.name
    return label || ''
  }

  /**
   * モーダルを開く
   *
   * @param currentStudyCategoryCode 現在の講習会トレーニング教材コード
   */
  public show(currentStudyCategoryCode: string): void {
    this.$loading.start()
    this.getStudyCategoryData()
    this.$loading.complete()
    this.selectModal.show(currentStudyCategoryCode)
  }

  /**
   * apiから講習会トレーニング教材のリストを取得
   */
  private getStudyCategoryData(): void {
    // TODO api実装の際修正
    this.studyCategoryList = [
      { id: 1, code: '1', name: 'ダミー1', textbookImagePath: 'img/dummy_study_category/textbook.png' },
      { id: 2, code: '2', name: 'ダミー2', textbookImagePath: null },
      { id: 3, code: '3', name: 'ダミー3', textbookImagePath: null },
      { id: 4, code: '4', name: 'ダミー4', textbookImagePath: null },
      { id: 5, code: '5', name: 'ダミー5', textbookImagePath: null },
      { id: 6, code: '6', name: 'ダミー6', textbookImagePath: null },
    ]
  }
}
